import { SVGProps } from '../types';

const PaypalIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.4855 24.5976L19.7798 22.6655L19.1242 22.6497H15.9937L18.1693 8.39152C18.1761 8.34834 18.198 8.30826 18.23 8.27975C18.2621 8.25124 18.3031 8.2356 18.346 8.2356H23.6246C25.3772 8.2356 26.5866 8.61244 27.2179 9.35637C27.5139 9.70535 27.7024 10.0701 27.7937 10.4714C27.8894 10.8926 27.891 11.3957 27.7976 12.0095L27.7909 12.0541V12.4474L28.0869 12.6208C28.3361 12.7575 28.5343 12.9139 28.6862 13.0929C28.9394 13.3914 29.1032 13.7707 29.1724 14.2202C29.2439 14.6826 29.2203 15.233 29.1032 15.856C28.9681 16.5725 28.7497 17.1967 28.4548 17.7073C28.1837 18.1778 27.8382 18.5682 27.4278 18.8706C27.0361 19.158 26.5708 19.3762 26.0446 19.5158C25.5347 19.653 24.9533 19.7222 24.3157 19.7222H23.9049C23.6112 19.7222 23.3259 19.8315 23.1019 20.0275C22.8773 20.2276 22.7288 20.501 22.6833 20.8L22.6522 20.974L22.1322 24.3796L22.1087 24.5046C22.1024 24.5442 22.0917 24.5639 22.0759 24.5773C22.0619 24.5895 22.0417 24.5976 22.022 24.5976H19.4855Z"
      fill="#28356A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.3678 12.0996C28.3522 12.2037 28.334 12.3101 28.3139 12.4194C27.6178 16.1136 25.2361 17.3898 22.1944 17.3898H20.6457C20.2737 17.3898 19.9601 17.6689 19.9023 18.0482L18.8848 24.7192C18.8471 24.9683 19.0328 25.1927 19.2758 25.1927H22.0227C22.3479 25.1927 22.6243 24.9485 22.6755 24.6169L22.7025 24.4727L23.2196 21.0804L23.2529 20.8944C23.3035 20.5617 23.5805 20.3173 23.9057 20.3173H24.3165C26.9778 20.3173 29.0612 19.2006 29.6701 15.9688C29.9244 14.6188 29.7928 13.4915 29.1197 12.6987C28.916 12.4597 28.6633 12.2612 28.3678 12.0996Z"
      fill="#298FC2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.6392 11.7995C27.5328 11.7674 27.4231 11.7384 27.3106 11.7122C27.1974 11.6866 27.0815 11.6639 26.9622 11.6441C26.5446 11.5743 26.087 11.5413 25.597 11.5413H21.4596C21.3576 11.5413 21.2608 11.565 21.1743 11.6081C20.9834 11.7029 20.8417 11.8896 20.8073 12.1182L19.9271 17.8802L19.9019 18.0482C19.9597 17.6689 20.2732 17.3898 20.6453 17.3898H22.194C25.2357 17.3898 27.6173 16.113 28.3134 12.4194C28.3342 12.3101 28.3517 12.2037 28.3674 12.0996C28.1913 12.003 28.0005 11.9204 27.7951 11.85C27.7444 11.8326 27.6921 11.8158 27.6392 11.7995Z"
      fill="#22284F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.8073 12.1182C20.8417 11.8896 20.9834 11.7029 21.1743 11.6087C21.2615 11.5656 21.3576 11.5418 21.4596 11.5418H25.597C26.0871 11.5418 26.5447 11.575 26.9623 11.6447C27.0816 11.6645 27.1975 11.6873 27.3106 11.7128C27.4232 11.7389 27.5329 11.7681 27.6393 11.8C27.6921 11.8163 27.7444 11.8332 27.7957 11.85C28.0011 11.9204 28.192 12.0037 28.368 12.0996C28.5752 10.7345 28.3663 9.80498 27.6522 8.9633C26.8648 8.03658 25.4439 7.64001 23.6257 7.64001H18.3469C17.9755 7.64001 17.6586 7.91911 17.6013 8.29905L15.4026 22.7038C15.3593 22.9888 15.5719 23.2459 15.85 23.2459H19.1089L20.8073 12.1182Z"
      fill="#28356A"
    />
  </svg>
);

export { PaypalIcon };
